module.exports = __webpack_public_path__ + "static/media/border-check.91bf20c2.svg";